import { Metadata } from 'next'

const metadata: Metadata = {
  title: 'Track Orders',
  description:
    'Easily track your shipments with ShipSticks. Get real-time updates and notifications.',
  alternates: {
    canonical: 'https://www.shipsticks.com/track-orders',
  },
}

export default metadata
